<div
  id="template-editor"
  class="template-editor madero-style"
  [ngClass]="{
    'active-component': componentsFactory.selected,
    'desktop-mode': !considerChromeBarHeight,
  }"
>
  <div class="template-editor-body">
    <div class="attribute-editor">
      <template-attribute-editor> </template-attribute-editor>
    </div>
    <div
      class="preview-holder-container"
      [ngClass]="{ 'hidden-xs': componentsFactory.selected }"
    >
      <div
        id="preview-holder"
        class="preview-holder"
        [ngClass]="{ 'hidden-xs': componentsFactory.selected }"
      >
        <presentation-preview> </presentation-preview>
      </div>
    </div>
  </div>

  <contextual-toolbar></contextual-toolbar>

  <template-editor-footer
    #navbar
    class="template-editor-footer tw-hidden"
    [ngClass]="{
      'hidden-xs': componentsFactory.selected,
      'navbar-fixed-bottom': !isCramped(),
    }"
  >
  </template-editor-footer>
</div>
